import React, { useEffect, useState } from 'react';
import ModalComponent from '../../components/ModalComponent';
import Button from 'react-bootstrap/Button';
import '../../assets/style/Modal.css';
import { FormGroup, Input, Label } from 'reactstrap';
import BasicDetails from '../../components/BasicDetails';
import ModalHeader from '../../components/ModalHeader';
import { CLICK_ACTIONS } from '../../utils/Constant';

import {
  candidateSelector,
  getCandidateDetails,
} from '../../features/assignGridSlice';
import CenterSpinner from '../../components/CenterSpinner';
import {
  CampaignDetailType,
  NoteType,
  UserType,
  LoggedUserType,
} from '../../utils/Types';
import { findCampaignDetails, getNoteDate } from '../../utils/Util';
import { loginSelector } from '../../features/loginSlice';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import {
  onActionPerform,
  saveComment,
} from '../onboarding/OnboardingPageHelper';
import { useLoader } from '../../loader/LoaderProvider';

interface IApproveModalProps {
  isOpen: boolean;
  candidateId?: number;
  toggleApproveModal: (action: string) => void;
}

const ApproveModal: React.FunctionComponent<IApproveModalProps> = ({
  isOpen,
  candidateId,
  toggleApproveModal,
}: IApproveModalProps) => {
  const [user, setUser] = useState<UserType>();
  const { showLoader, setShowLoader } = useLoader();
  const [campaignDetail, setCampaignDetail] = useState();
  const dispatch = useAppDispatch();
  const [comment, setComment] = useState<string>('');
  const userDetails: UserType = useAppSelector(candidateSelector).user;
  const notes: NoteType[] = useAppSelector(candidateSelector).notes;
  const campaignDetailsInfo: CampaignDetailType[] =
    useAppSelector(candidateSelector).campaignDetails;
  const loggedUser: LoggedUserType = useAppSelector(loginSelector).user;

  useEffect(() => {
    setCampaignDetail(findCampaignDetails(campaignDetailsInfo));
  }, [campaignDetailsInfo]);
  /**
   * Call dispatch action for calling API to get candidate details.
   */
  const getUserDetails = () => {
    if (candidateId) {
      setShowLoader(true);
      dispatch(getCandidateDetails(candidateId));
    }
  };

  const onAction = (action: string) => {
    onActionPerform(
      action,
      candidateId,
      loggedUser,
      comment,
      dispatch,
      setShowLoader,
      toggleApproveModal
    );
  };
  useEffect(() => {
    if (candidateId === userDetails.candidateid) {
      setUser(userDetails);
      setShowLoader(false);
    } else if (!userDetails.candidateid) {
      setShowLoader(false);
    }
  }, [userDetails]);
  useEffect(() => {
    getUserDetails();
  }, [candidateId]);

  const getCommentAndAction = () => (
    <>
      <div className="bg-comment p-4 my-2 mx-4 rounded">
        <div className="mb-3">
          <FormGroup>
            <Label for="comment" className="model-comment-title">
              Comments
            </Label>
            <Input
              disabled={
                loggedUser.roleId != 15 && loggedUser.roleId != 41
                  ? true
                  : false
              }
              id="comment"
              name="comment"
              type="textarea"
              maxLength={250}
              value={comment}
              placeholder="Please Comment"
              className="rounded border model-comment-area"
              onChange={(event) => setComment(event.target.value)}
            />
          </FormGroup>
          <Button
            disabled={
              loggedUser.roleId != 15 && loggedUser.roleId != 41 ? true : false
            }
            variant="primary"
            className="cl-btn-primary"
            onClick={() => {
              saveComment(
                comment,
                candidateId,
                dispatch,
                setShowLoader,
                getUserDetails,
                setComment
              );
            }}
          >
            Save
          </Button>
        </div>

        <div className="bg-white rounded border px-4 pt-3 pb-3">
          <Label for="comment" className="model-comment-title">
            Log Details
          </Label>
          <div className="modal-log-div">
            <ul className="li-item model-log-value">
              {notes &&
                notes.length > 0 &&
                notes?.map((noteItem) => (
                  <li
                    className="mt-1"
                    key={noteItem.notesId ?? noteItem.notesid}
                  >
                    {getNoteDate(noteItem)}
                    {noteItem.notesdescription}
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center">
        <Button
          disabled={
            loggedUser.roleId != 15 && loggedUser.roleId != 41 ? true : false
          }
          variant="primary"
          className="m-1 cl-btn-primary"
          onClick={() => {
            onAction(CLICK_ACTIONS.APPROVE);
          }}
        >
          Approve
        </Button>
        <Button
          disabled={
            loggedUser.roleId != 15 && loggedUser.roleId != 41 ? true : false
          }
          variant="outline-primary"
          className="m-1 cl-btn-outline-primary"
          onClick={() => {
            onAction(CLICK_ACTIONS.REJECT);
          }}
        >
          Reject
        </Button>
      </div>
    </>
  );

  return (
    <ModalComponent
      isOpen={isOpen}
      toggle={() => {
        toggleApproveModal(CLICK_ACTIONS.NO_ACTION);
      }}
      className="modalWrapper"
      backdrop="static"
    >
      <div className="bg-white p-2 rounded border">
        <ModalHeader
          photoUrl={user?.photo}
          toggle={() => {
            toggleApproveModal(CLICK_ACTIONS.NO_ACTION);
          }}
        />
        <BasicDetails user={user} campaignDetail={campaignDetail} />
        {getCommentAndAction()}
        <CenterSpinner showLoader={showLoader} />
      </div>
    </ModalComponent>
  );
};

export default ApproveModal;
